import { render, staticRenderFns } from "./CoursewareStructuralElementCommentsOverview.vue?vue&type=template&id=36f7786c&"
import script from "./CoursewareStructuralElementCommentsOverview.vue?vue&type=script&lang=js&"
export * from "./CoursewareStructuralElementCommentsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports